import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import React, { Fragment } from 'react';
import { format, parseISO } from 'date-fns';
import baseStyles, { mergeStyles } from '@nerdwallet/base-styles/react';
import baseStylesVars from '@nerdwallet/base-styles/variables';
import { Box } from '../Box/Box';
import { Link } from '../Link/Link';
import { Text } from '../Text/Text';
import { Tooltip } from '../Tooltip/Tooltip';

/**
 * If date parsing fails, don't mount 'Invalid Date'.
 *
 * @param authoringDate ISO8601 date string.
 * @returns null or formatted date string.
 */
var getDate = function getDate(authoringDate) {
  try {
    return format(parseISO(authoringDate), 'PP');
  } catch (e) {
    return null;
  }
};

var renderDelimiter = function renderDelimiter(index, authors) {
  return index === authors.length - 1 ? '' : ', ';
}; // Alternate between Link and Type elements depending on if authors supply an href


var renderAuthors = function renderAuthors(authors) {
  return authors && authors.map(function (author, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: author.name
    }, author.url ? /*#__PURE__*/React.createElement("span", baseStyles('nowrap'), /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, /*#__PURE__*/React.createElement(Link, {
      href: author.url
    }, author.name), /*#__PURE__*/React.createElement(Text, {
      tone: "light"
    }, renderDelimiter(index, authors)))) : /*#__PURE__*/React.createElement(Text, {
      size: "small",
      light: true
    }, /*#__PURE__*/React.createElement("span", baseStyles('nowrap'), author.name, renderDelimiter(index, authors))), ' ');
  });
};

var reviewerTooltip = /*#__PURE__*/React.createElement(Tooltip, _extends({
  label: "\u202F" // narrow no-break space. Because I can't use an element with currency spacing here

}, baseStyles('color-neutral-darker'), {
  content: /*#__PURE__*/React.createElement(Box, mergeStyles(baseStyles('color-neutral-darker', 'text-small', 'max-width-prose-narrow'), {
    style: {
      whiteSpace: 'normal'
    }
  }), "At NerdWallet, we have such confidence in our accurate and useful content that we let outside experts inspect our work.")
}));

var renderReviewers = function renderReviewers(reviewers) {
  return reviewers === null || reviewers === void 0 ? void 0 : reviewers.map(function (reviewer, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: reviewer.name
    }, reviewer.url ? /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, /*#__PURE__*/React.createElement("span", baseStyles('nowrap'), /*#__PURE__*/React.createElement(Link, {
      href: reviewer.url
    }, reviewer.name), /*#__PURE__*/React.createElement(Text, {
      tone: "light"
    }, renderDelimiter(index, reviewers)), index === reviewers.length - 1 && reviewerTooltip)) : /*#__PURE__*/React.createElement(Text, {
      size: "small",
      light: true
    }, /*#__PURE__*/React.createElement("span", baseStyles('nowrap'), reviewer.name, renderDelimiter(index, reviewers), index === reviewers.length - 1 && reviewerTooltip)), ' ');
  });
};

var dividerClasses = ['border-left-1', 'padding-left-2', 'margin-left-2', 'border-neutral-light', 'margin-bottom-2'];
export var AuthorByline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var authors = props.authors,
      authoringDate = props.authoringDate,
      _props$reviewers = props.reviewers,
      reviewers = _props$reviewers === void 0 ? [] : _props$reviewers;
  var hasReviewers = (reviewers === null || reviewers === void 0 ? void 0 : reviewers.length) > 0;
  return /*#__PURE__*/React.createElement(Box, {
    "data-currency": "AuthorByline",
    ref: ref,
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Box, mergeStyles(baseStyles('display-flex', 'flex-wrap'), {
    style: {
      // Counter the left and bottom margin, spacing, and border applied to each flexed element
      marginLeft: "calc(".concat(baseStylesVars.spacing['2'], " * -2 - 1px)"),
      marginBottom: "calc(".concat(baseStylesVars.spacing['2'], " * -1)")
    }
  }), /*#__PURE__*/React.createElement(Box, baseStyles(dividerClasses), hasReviewers && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    tone: "light"
  }, "Written by", ' '), renderAuthors(authors)), hasReviewers && /*#__PURE__*/React.createElement(Box, baseStyles(dividerClasses), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    tone: "light"
  }, "Reviewed by", ' '), renderReviewers(reviewers)), authoringDate && /*#__PURE__*/React.createElement(Box, baseStyles(dividerClasses, 'nowrap'), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    tone: "light"
  }, getDate(authoringDate)))));
});
AuthorByline.displayName = 'AuthorByline';